import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 3q1.875 0 3.513.713a9.2 9.2 0 0 1 2.85 1.925 9.2 9.2 0 0 1 1.924 2.85A8.7 8.7 0 0 1 21 12q0 1.875-.713 3.513a9.2 9.2 0 0 1-1.925 2.85 9.2 9.2 0 0 1-2.85 1.924A8.7 8.7 0 0 1 12 21q-3.45 0-6.013-2.287T3.05 13H5.1q.35 2.6 2.312 4.3Q9.375 19 12 19q2.925 0 4.963-2.037Q19 14.926 19 12q0-2.925-2.037-4.963Q14.926 5 12 5a6.75 6.75 0 0 0-3.225.8A7.4 7.4 0 0 0 6.25 8H9v2H3V4h2v2.35a8.7 8.7 0 0 1 3.112-2.475A8.9 8.9 0 0 1 12 3m1 8.6 3.2 3.2-1.4 1.4-3.8-3.8V7h2z" })
});
export default SvgHistory;
